import styled from 'styled-components'

// components
import { Box, Flex } from 'components/Box'
import Heading from 'components/Heading'
import { TabList, Tab, Tabs, TabPanel } from 'components/Tabs'

import { TabProps, TabButton } from 'components/Tabs/Tab'

type StyledTabProps = Pick<TabProps, 'isDisabled'>

const StyledTabList = styled(TabList)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  box-shadow: 0px 2px 0px ${({ theme }) => theme.colors.border.dark.extraHigh}
    inset;
`

const StyledTab = styled(Tab)<StyledTabProps>`
  width: 100%;

  & > * {
    width: 100%;
  }

  ${TabButton} {
    ${({ theme, isDisabled }) =>
      isDisabled && `color: ${theme.colors.text.dark.disabled};`}
  }
`

const Breadcrumbs = styled.ol`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
  line-height: 1.5;

  padding: 0;
  list-style: none;

  li {
    display: inline-block;

    &:not(:last-child):after {
      content: '/';
      margin: 0 4px;
    }

    &:last-child {
      color: ${({ theme }) => theme.colors.text.dark.base};
    }
  }
`

const BreadcrumbItem = styled.li`
  word-break: break-all;
  overflow-wrap: anywhere;
`

const DocumentInfo = styled(Flex)`
  flex-wrap: wrap;
`

const DocumentInfoTitle = styled(Heading.H3)`
  margin: 16px 0 0;
`

const DocumentInfoItemWrapper = styled(Box)`
  width: 50%;
`

export {
  StyledTabList as TabList,
  StyledTab as Tab,
  Tabs,
  TabPanel,
  Breadcrumbs,
  BreadcrumbItem,
  DocumentInfo,
  DocumentInfoTitle,
  DocumentInfoItemWrapper,
}
